module.exports = __webpack_public_path__ + "img/map.e69f9290.png";